/*
 * Quick Shop drawer for product cards.
 * Previously bound by the Boost / SwatchKing scripts; this is the app-independent replacement.
 * Any card inside an element with [data-product-url] (pointing to ?view=quick-view) and a .quick_shop
 * button opens the #custom_quickview drawer rendered by snippets/quick-view-product.liquid.
 */
(function ($) {
  if (!$ || window.agQuickShopInit) return;
  window.agQuickShopInit = true;

  function closeQuickView() {
    $('.quci_view_drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
    $('.overly').removeClass('active');
  }

  function openQuickView(sectionHtml) {
    $('.quick_drawer_inner').html(sectionHtml);
    $('body').addClass('overflow-hidden');
    $('.overly').addClass('active');
    $('.quci_view_drawer').addClass('active');
  }

  function findQuickView(html) {
    // Only accept the compact quick-view layout (sections/quick-view.liquid), never the full product page
    var $section = $('<div>').append($.parseHTML(html, document, true)).find('section[id^="MainProduct-"]').filter(function () {
      return $(this).find('.quick_top_img').length > 0;
    });
    return $section.length ? $section.first().html() : null;
  }

  // Sold-out size pills must NOT open the quick view — stop the click from reaching .quick_shop
  $(document).on('click', '.card-size-pill--sold-out', function (event) {
    event.stopPropagation();
  });

  $(document).on('click', '.quick_shop', function (event) {
    var url = $(this).closest('[data-product-url]').attr('data-product-url');
    if (!url) return;
    event.preventDefault();

    // Render the quick-view section file directly so the product's own template (and ?view resolution) can't change the layout
    var productPath = url.split('?')[0];
    var $trigger = $(this).addClass('loading');

    function fallback() {
      return $.ajax({ url: url, type: 'GET', dataType: 'html' }).then(findQuickView);
    }

    $.ajax({ url: productPath + '?section_id=quick-view', type: 'GET', dataType: 'html' })
      .then(function (html) {
        return findQuickView(html) || fallback();
      }, fallback)
      .done(function (section) {
        if (section) {
          openQuickView(section);
        } else {
          window.location.href = productPath;
        }
      })
      .fail(function () {
        window.location.href = productPath;
      })
      .always(function () {
        $trigger.removeClass('loading');
      });
  });

  $(document).on('change', '.quci_view_drawer .product-form input[name="id"]', function () {
    var src = $(this).parents('.product').find('.product__media-item.is-active .product__media img').attr('src');
    if (src) $('.data-img').find('img').attr('src', src);
  });

  $(document).on('click', '.quci_view_drawer .guide_cross', closeQuickView);

  $(document).on('click', 'body', function (event) {
    var $drawer = $('#custom_quickview');
    if (!$drawer.hasClass('active')) return;
    var $container = $('#custom_quickview, .drawer__inner');
    if (!$container.is(event.target) && $container.has(event.target).length === 0) closeQuickView();
  });

  $(document).on('keyup', function (event) {
    if (event.key === 'Escape' && $('#custom_quickview').hasClass('active')) closeQuickView();
  });
})(window.jQuery);
